<template lang="pug">
.container
  h1.main_title Smart-controller Activity
  .loader(v-if="dataLoading")
  .col-md-12.function_bar(v-else)
    div
      label.filter_label Activity: 
      v-select(
        v-bind:value.sync='filterTypeValue'
        v-bind:options='filterTypeOpts'
        placeholder="None"
      )
    div
      label.filter_label Model: 
      v-select(
        v-bind:value.sync='filterModelValue'
        v-bind:options='filterModelOpts'
        placeholder="None"
      )
    div
      label.filter_label Start from:
      input.filter_option.filter_date(
        type="date"
        v-model="filterDateStartValue"
        v-bind:max="today"
      )
    div
      label.filter_label End at:
      input.filter_date(
        type="date"
        v-model="filterDateEndValue"
        v-bind:min="filterDateStartValue"
        v-bind:max="today"
      )
  .output_data_container(v-if="outputData.length > 0")
    pagination(
      v-bind:count-of-page.sync="countOfPage"
      v-bind:curr-page.sync="currentPage"
      v-bind:count-of-pagination="countOfPagination"
      v-bind:curr-pagination-sec.sync='currPaginationSec'
      v-bind:target-ary.sync='outputData'
      v-if="outputData.length > 10")
    .col-md-12.no_pad
      table.table.table-hover.table-bordered
        tr
          th Time
            .pull-right
              span.glyphicon(
                :class="sortIconCreator('createdAt', 'attribute')"
                @click="sortBy('createdAt')"
              )
          th Activity
            .pull-right
              span.glyphicon(
                :class="sortIconCreator('type', 'attribute')"
                @click="sortBy('type')"
              )
          th Serial Number
            .pull-right
              span.glyphicon(
                :class="sortIconCreator('serialNum', 'alphabet')"
                @click="sortBy('serialNum')"
              )
          th MAC
            .pull-right
              span.glyphicon(
                :class="sortIconCreator('data.mac', 'alphabet')"
                @click="sortBy('data.mac')"
              )
          th Model
            .pull-right
              span.glyphicon(
                :class="sortIconCreator('data.model', 'alphabet')"
                @click="sortBy('data.model')"
              )
          th Version
            .pull-right
              span.glyphicon(
                :class="sortIconCreator('data.fwVersion', 'attribute')"
                @click="sortBy('data.fwVersion')"
              )
        tr(v-for="log in outputData | limitBy countOfPage pageStart")
          td {{ log.createdAt | timeFormat 'YYYY/MM/DD hh:mm:ss A' }}
          td.text-capitalize(:class="typeClassCreator(log.type)")
            | {{ log.type }} 
            span.text-lowercase(style="font-size: 8px") {{ log.type === 'update' ? `(from ${log.data.after.ip})` : ''}}
          td {{ log.serialNum }}
          td(v-if="log.type === 'update'") {{ log.data.after.mac }}
          td(v-else) {{ log.data.mac }}
          td.text-uppercase(v-if="log.type === 'update'") {{ log.data.after.model }}
          td.text-uppercase(v-else) {{ log.data.model }}
          td(v-if="log.type === 'update'") {{ log.data.after.fwVersion }}
          td(v-else) {{ log.data.fwVersion }}
  h2.text-center.text-muted(v-else) No Data
</template>

<script>
  import { getSmartCtrlActRef } from '../../index.js'
  import pagination from '../common/Pagination'
  import { select } from 'vue-strap'
  import moment from 'moment'
  import _ from 'lodash'

  export default {
    props: [],
    components: {
      'v-select': select,
      pagination
    },
    data () {
      return {
        /* default */
        outputData: [],
        /* data status */
        fbSmartCtrlActLoaded: false,
        /* pagination */
        countOfPage: 10,
        countOfPagination: 5,
        currentPage: 1,
        currPaginationSec: 1,
        /* filter options & values */
        filterTypeValue: 'Any',
        filterTypeOpts: [
          {label: 'Any', value: 'Any'},
          {label: 'Create', value: 'create'},
          {label: 'Delete', value: 'delete'},
          {label: 'Update', value: 'update'}
        ],
        filterModelValue: 'Any',
        filterModelOpts: [
          {label: 'Any', value: 'Any'},
          {label: 'ASPEED', value: 'aspeed'},
          {label: 'ITE', value: 'ite'}
        ],
        today: moment().format('YYYY-M-D'),
        filterDateStartValue: '',
        filterDateEndValue: '',
        lang: 'en',
        /* sort data */
        currentSortOptions: {
          'createdAt': false,
          'type': null,
          'data.mac': null,
          'serialNum': null,
          'data.model': null,
          'data.fwVersion': null
        }
      }
    },
    vuex: {
      getters: {
        user: state => state.user
      }
    },
    firebase () {
      return {
        fbSmartCtrlAct: {
          source: getSmartCtrlActRef(),
          readyCallback: () => {
            this.fbSmartCtrlActLoaded = true
          }
        }
      }
    },
    computed: {
      dataLoading () {
        if (this.user.role === 'admin' && this.fbSmartCtrlActLoaded) {
          const fbsca = [...this.fbSmartCtrlAct]
          /* filter data */
          const filterTypeResult = this.filterTypeValue === 'Any'
            ? fbsca
            : _.filter(fbsca, s => s.type === this.filterTypeValue)
          // console.log(filterTypeResult)

          const filterModelResult = this.filterModelValue === 'Any'
            ? filterTypeResult
            : _.filter(filterTypeResult, ({data}) => data.model === this.filterModelValue)

          const filterDateStartRESULT = this.filterDateStartValue === ''
            ? filterModelResult
            : _.filter(filterModelResult, s => s.createdAt >= new Date(this.filterDateStartValue).getTime())

          const filterDateEndRESULT = this.filterDateEndValue === ''
            ? filterDateStartRESULT
            : _.filter(filterDateStartRESULT, s => s.createdAt <= (new Date(this.filterDateEndValue).getTime()) + 86399000) /* add 23hr 59m 59s */

          /* sort data */
          const sortType = []
          const AorDESC = []
          _.forEach(this.currentSortOptions, (value, key) => {
            if (value !== null) {
              sortType.push(key)
              AorDESC.push(value ? 'asc' : 'desc')
            }
          })
          // console.log(sortType, AorDESC)

          this.outputData = _.orderBy(filterDateEndRESULT, sortType, AorDESC)
          return false
        } else {
          return true
        }
      },
      totalPrice () {
        let su = 0
        _.forEach(this.outputData, (o) => {
          su += o.price * 100000
          // console.log(o.price, su)
        })
        // console.log(su / 100000)
        return su / 100000
      },
      pageStart () {
        return (this.currentPage - 1) * this.countOfPage
      },
      filterCollection () {
        const {filterTypeValue, filterModelValue, filterDateStartValue, filterDateEndValue} = this
        return {
          filterTypeValue, filterModelValue, filterDateStartValue, filterDateEndValue
        }
      }
    },
    ready () {

    },
    methods: {
      download () {
        const csvTitles = ['Time', 'Type', 'Source MAC', 'Vendor', 'To', 'Price (€)']
        const dataKeys = ['createdAt', 'type', 'mac', 'from', 'to', 'price']
        let csvContent = csvTitles.join() + '\r\n'
        let csvToDown = this.outputData
        for (let column of csvToDown) {
          let columnData = dataKeys.map(k => {
            if (k === 'createdAt') {
              return moment(column[k]).format('YYYY-M-D h:mm:ss a')
            } else {
              return column[k]
            }
          })
          csvContent = csvContent + columnData.join() + '\r\n'
        }
        csvContent += ',,,,,\r\n'
        csvContent += `,,,,Total Amount: ${this.outputData.length},Total Price: ${this.totalPrice}`
        let textFileAsBlob = new window.Blob([csvContent], {type: 'text/plain'})
        let atag = this.$els.download
        atag.download = 'exportLog.csv'
        atag.href = window.URL.createObjectURL(textFileAsBlob)
        try {
          console.log('a click', textFileAsBlob)
          atag.click()
        } catch (e) {  // throws when IE
          window.navigator.msSaveBlob(textFileAsBlob, 'exportLog.csv')
        }
      },
      sortBy (type) {
        const { currentSortOptions } = this
        switch (currentSortOptions[type]) {
          case null:
            currentSortOptions[type] = true
            break
          case false:
            currentSortOptions[type] = null
            break
          case true:
            currentSortOptions[type] = false
            break
        }
      },
      sortIconCreator (colName, sorType) {
        const icon = {
          'alphabet': 'glyphicon-sort-by-alphabet',
          'order': 'glyphicon-sort-by-order',
          'attribute': 'glyphicon-sort-by-attributes'
        }
        const { currentSortOptions } = this
        return currentSortOptions[colName] !== null
          ? currentSortOptions[colName]
            ? icon[sorType]
            : `${icon[sorType]}-alt`
          : 'glyphicon-sort sort_default'
      },
      typeClassCreator (type) {
        switch (type) {
          case 'delete':
            return 'btn-danger'
          case 'create':
            return 'btn-success'
          case 'update':
            return 'btn-info'
        }
      }
    },
    watch: {
      filterCollection: {
        deep: true,
        handler: function (nv) {
          this.currentPage = 1
          this.currPaginationSec = 1
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.filter_container {
  display: flex;
  justify-content: space-between;
  padding: 15px;
}

.filter_date {
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 34px;
}

.filter_label {
  padding-right: 6px;
}

.filter_option {
  margin-right: 12px;
}

.sort_default {
  color: rgba(199, 199, 199, 0.5);
}

.table_overview {
  padding: 4px 6px;
}
</style>



// WEBPACK FOOTER //
// Activity.vue?69030f1c